import { ResourceOptions } from 'react-admin';
import '../dataProvider';
import { Resources } from '../../resource';

// Data-only resource (rendered as a tab inside Notification Configs page; no route of its own).
export const name = Resources.notificationConfigsTemplates;
export const options: ResourceOptions = {
  label: 'resource.notificationConfigsTemplates',
};
